var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 229,
    viewBox: "0 0 224 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5147 149.857V208.238L86.45 229L129.675 204.024L136.965 199.81V154.174L86.45 124.984V170.619L50.5147 149.857V108.333V49.9524L43.225 54.1665L0 79.1427V120.667L50.5147 149.857ZM136.965 -6.10352e-05L93.7397 24.9762L86.45 29.1902V74.8258L136.965 104.016V58.3806L172.9 79.1427L223.415 108.333V149.857L180.19 174.833L172.9 179.048V120.667V20.7621L136.965 -6.10352e-05Z",
    fill: "#F48B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubLogo);
export default __webpack_public_path__ + "static/media/hub-logo.760ace693eb1a241e61d87d6ee36f976.svg";
export { ForwardRef as ReactComponent };